/*
 * Authors: mariushirjanu
 * Created: 26/01/2024
 */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IDashboardGroup, IDashboardSection } from './dashboard.component';
import { DashboardCode } from './dashboard-metadata.service';
import { TranslationCategory } from '@app/shared/services/ga-state.service';
import { IDashboardMetadataReports, IDashboardStoredReports } from '@app/shared/report/dashboard-data.service';

@Component({
  selector: 'dashboard-sections',
  template: `
    <!-- define the template for dashboard sections -->
    <ng-template #dashboardSectionsTemplate let-sections="sections" let-group="group">
      <table class="sections-table" *ngIf="sections">
        <tr *ngFor="let section of sections" [id]="section.id">
          <td class="hint">
            <span><i *ngIf="section.extraIcon" [ngClass]="section.extraIcon.classes" [title]="section.extraIcon.legend"></i></span>
          </td>

          <td class="section-cell">
            <dashboard-section
              [section]="section"
              [screen]="screen"
              [getInfoComponentInputs]="getInfoComponentInputs"
              [reportMetadata]="dashboardMetadataReports && dashboardMetadataReports[section?.report?.id || section?.report?.browseListConfig?.reportId]"
              [storedReportData]="dashboardStoredReports && dashboardStoredReports[section?.report?.storedReport]"
              (onRefreshSection)="onRefreshSections.emit({ sections: [$event], group: group })"
            ></dashboard-section>
          </td>
        </tr>
      </table>
    </ng-template>

    <!-- display template for dashboard sections with groups -->
    <ng-container *ngFor="let group of groups">
      <editable-text  *ngIf="group.sections.length" [key]="group.key" [screen]="screen" menu="title,info" highlight="h3 a"></editable-text>
      <collapsible-pane *ngIf="group.sections.length" [title]="group.name | translate" [collapsed]="group.collapsed" (onChange)="toggleGroup(group, $event)">
        <div class="group-info" *ngIf="group.info !== (group.info | translate)" [innerHTML]="group.info | translate | safe: 'html'"></div>
        <div class="collapsible-title-extra">
          <span class="detailed-report-link">
            <a href="javascript:void(0)" (click)="onRefreshSections.emit({ sections: group.sections, group: group })"><i class="fa fa-refresh"></i></a>
          </span>
          <span class="report-result-count">
            <activity-indicator *ngIf="group.loading"></activity-indicator>
            <span *ngIf="!group.loading && (group.rowCount === 0 || group.rowCount)" class="warn">{{ group.indicator }}</span>
          </span>
        </div>
        <ng-container [ngTemplateOutlet]="dashboardSectionsTemplate" [ngTemplateOutletContext]="{ sections: group.sections, group: group }"></ng-container>
      </collapsible-pane>
    </ng-container>

    <!-- display template for dashboard sections without groups -->
    <ng-container [ngTemplateOutlet]="dashboardSectionsTemplate" [ngTemplateOutletContext]="{ sections: sections }"></ng-container>
  `,
  styleUrls: ['./dashboard.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardSectionsComponent implements OnInit, OnChanges {
  @Input() public dashboardCode:DashboardCode;
  @Input() public dashboardMetadataReports:IDashboardMetadataReports;
  @Input() public dashboardStoredReports:IDashboardStoredReports;
  @Input() public sections:IDashboardSection[];
  @Input() public groups?:IDashboardGroup[];
  @Input() public getInfoComponentInputs:Function;
  @Output() public onRefreshSections:EventEmitter<{ sections:IDashboardSection[], group?:IDashboardGroup }> = new EventEmitter<{ sections:IDashboardSection[], group?:IDashboardGroup }>();

  public screen:string;

  public ngOnInit():void {
    this.screen = `${TranslationCategory.DASHBOARD}.${this.dashboardCode}`.toUpperCase();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if(changes.dashboardMetadataReports){
      this.dashboardMetadataReports = changes.dashboardMetadataReports.currentValue;
    }

    if(changes.dashboardStoredReports){
      this.dashboardStoredReports = changes.dashboardStoredReports.currentValue;
    }
  }

  public toggleGroup(group:IDashboardGroup, collapsed:boolean):void {
    group.collapsed = collapsed;
  }
}